import React, { useContext, useMemo } from "react";
import { Typography, Grid, Stack, Slider, Divider, colors, Card, Box } from "@mui/joy";
import { GET_ALL_VALIDATION_T } from "../../types";
import TableCustom from "../../components/TableCustome";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";
import { green, grey, red } from "@mui/material/colors";
import formatDateToDDMMYYYY from "../../utils/formatDateToDDMMYYYY";
import { CardMedia } from "@mui/material";
import PageLooperContext from "../../providers/PageLooperContext";
import getProduitImageUrl from "../../utils/getProduitImageUrl";
import Colors from "../../constant/colors";
import { getPrixProduitMarcheParProvince } from "../../utils/getPrixProduitMarcheParProvince";

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

// Définir la nouvelle interface pour les données entrantes du composant
interface MarcheCollectes {
    marche: string;
    collectes: GET_ALL_VALIDATION_T[];
}

const PageContentProduitProvince: React.FC<{
    produit: string;
    province: string;
    data: MarcheCollectes[]; // La donnée reçue est un tableau de MarcheCollectes
}> = ({ produit, province, data}) => {
    const { apiData } = useContext(PageLooperContext);

    // Utiliser la fonction utilitaire pour traiter les données et obtenir les informations nécessaires
    const processedData = getPrixProduitMarcheParProvince(data);

    // Trier les marchés pour l'affichage
    const marches = processedData.map((p) => p.marche);

    // Préparer les lignes du tableau avec les données traitées, en incluant les "gaps"
    const tableRows = [
        {
            label: "Prix actuel",
            values: processedData.map((p) =>
                p.prixActuel !== null ? Math.round(p.prixActuel).toLocaleString() + " FCFA" : "-"
            ),
            center: true
        },
        {
            label: "Date actuelle",
            values: processedData.map((p) => formatDateToDDMMYYYY(p.dateActuelle) || "-"),
        },
        // {
        //     label: "Nbr de collectes actuel",
        //     values: processedData.map((p) => (p.nbrCollecteActuel !== null ? p.nbrCollecteActuel.toString() : "-")),
        // },
        'gap', // Ajout d'une ligne de séparation après les données actuelles
        {
            label: "Prix précédent",

            values: processedData.map((p) =>
                p.prixPrecedent !== null ? Math.round(p.prixPrecedent).toLocaleString() + " FCFA" : "-"
            ),
        },
        {
            label: "Date précédente",

            values: processedData.map((p) => formatDateToDDMMYYYY(p.datePrecedente) || "-"),
        },
        // {
        //     label: "Nbr de collectes précédent",

        //     values: processedData.map((p) => (p.nbrCollectePrecedente !== null ? p.nbrCollectePrecedente.toString() : "-")),
        // },
        'gap', // Ajout d'une ligne de séparation après les données précédentes
      {
  label: "Evolution %",
  values: processedData.map((p) => {
    if (p.evolution === null) return "-";

    const arrow =
      p.evolution > 0 ? "⬆️" :
      p.evolution < 0 ? "⬇️" : "";

    const color =
      p.evolution > 0 ? red[500] :
      p.evolution < 0 ? green[500] :
      grey[500];

    return (
      <span style={{ color }}>
        {arrow} {Math.abs(p.evolution).toFixed(2)}%
      </span>
    );
  }),
}
    ];

    const codeProduit = useMemo(() => (apiData.find((p) => p.produit?.nomProduit === produit)?.produit?.codeProduit), [apiData, produit])


    return (
        <Stack sx={{ height: '100vh', maxHeight: '100vh', p: 2, gap: 1, overflow: 'hidden', bgcolor: '#f5f7fa' }}>
            <Typography
                level="h4"
                fontSize={"2vw"}
                textColor={grey[700]}
                fontWeight={600}
            >
                Prix de
                {` `}<Typography
                    fontWeight={700}
                    textColor={green[900]}
                >{produit}</Typography> {` `}
                dans la Province de
                {` `}
                <Typography
                    fontWeight={700}
                   sx={{ color: Colors.secondary }}
                >{province}</Typography>
                                
              
                

                {/* <Typography
                    fontWeight={700}
                >
                    {part && `Partie ${part} `}
                </Typography> */}
            </Typography>
            {/* <Grid container spacing={2} alignItems={'flex-start'} > */}
                <Grid xs={12} md={10} sx={{ display: 'flex', flexDirection: 'column', gap: 1, minHeight: 0 }}>
                     <Card variant="outlined" sx={{ flex: 1, p: 1, overflow: 'auto' }}>
                        <Stack direction="row" gap={2}>
 <CardMedia
                        component={'img'}
                        src={getProduitImageUrl(codeProduit || '')}
                    // sx={{ flex:1, maxHeight:'40%' }}
                                                    sx={{ width: 200, height: 200, borderRadius: 2, objectFit: "cover", boxShadow: 'sm' }}

                    />
                    <Box sx={{ flex: 1 }}>
<TableCustom
                        columns={[
                            { label: "#", key: "label" },
                            ...marches.map((m) => ({ label: m, key: m, center: true })),
                        ]}
                        data={tableRows.map((row) => {
                            if (row === 'gap') {
                                return 'gap'; // Retourne la chaîne de caractères si c'est un "gap"
                            }

                            //@ts-ignore
                            const obj: any = { label: row.label };
                            //@ts-ignore
                            row.values.forEach((v, i) => {
                                obj[marches[i]] = <b>{v}</b>;
                            });
                            return obj;
                        })}
                    />
                    </Box>
                    
                        </Stack>
                        </Card>
                   
                </Grid>
                 


   {/* POINTS À RETENIR START */}
                {/* <Grid xs={12} md={3}  >
                    
                    <Stack
                        mt={2}
                    >
                        <Typography level="h3" fontSize={"1.5vw"}>
                            Points à retenir :
                        </Typography>

                        <Divider
                            sx={{
                                width: 50,
                                height: 10,
                                borderRadius: 50,
                                bgcolor: green[800]
                            }}
                        />

                        <Stack
                            component="ul"
                            mt={1}
                            fontSize="0.9vw"
                            gap={1}
                        >
                            {processedData.length > 1 && (
                                <li>
                                    Le prix de l'oignon est relativement plus bas dans le marché de{" "}
                                    {
                                        processedData.reduce((prev, cur) =>
                                            cur?.prixActuel !== null && cur?.prixActuel < (prev?.prixActuel ?? Infinity) ? cur : prev
                                        ).marche
                                    }.
                                </li>
                            )}

                            {processedData.map((p, i) => {
                                if (p.prixActuel === null || p.prixPrecedent === null) return null;

                                const difference = p.prixActuel - p.prixPrecedent;
                                const tendance = difference > 0 ? "à augmenté" : difference < 0 ? "à diminué" : "est resté stable";
                                const valeurAbs = Math.abs(difference).toFixed(0).toLocaleString();

                                return (
                                    <li key={i}>
                                        <b>{p.marche}</b>,
                                        {p.nbrCollecteActuel && p.nbrCollecteActuel > 1
                                            ? <> avec <b>{p.nbrCollecteActuel}</b> fiches, </>
                                            : " "}
                                        le prix de <b>{produit}</b>  {tendance}
                                        {difference !== 0 && <> de <b>{valeurAbs} FCFA</b></>}
                                         {" "} depuis la date du  {" "}
                                        <b>{formatDateToDDMMYYYY(p.datePrecedente)}</b>.
                                    </li>
                                );
                            })}
                        </Stack>
                    </Stack>
                </Grid> */}
                   {/* POINTS À RETENIR START */}
{/* POINTS À RETENIR START */}
{/* <Grid xs={12} md={3}>
  <Stack
    mt={2}
    p={2}
    sx={{
      bgcolor: 'rgba(13, 189, 19, 0.04)', // Un vert très léger pour le fond
      borderRadius: '16px',
      border: '1px solid',
      borderColor: 'divider',
    }}
  >
    <Typography level="h3" fontSize={"1.3vw"} fontWeight="bold" color="neutral">
      Points à retenir :
    </Typography>

    <Divider
      sx={{
        width: 60,
        height: 6,
        borderRadius: 50,
        bgcolor: 'green.600',
        my: 1.5
      }}
    />

    <Stack component="ul" spacing={2} sx={{ p: 0, listStyle: 'none' }}>
      {processedData.length > 1 && (
        <Typography component="li" fontSize="0.85vw" sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
          <span style={{ color: '#2e7d32' }}>•</span>
          <span>
            Le prix de {produit} est relativement plus bas dans le marché de{" "}
            <b>
              {processedData.reduce((prev, cur) =>
                cur?.prixActuel !== null && cur?.prixActuel < (prev?.prixActuel ?? Infinity) ? cur : prev
              ).marche}
            </b>.
          </span>
        </Typography>
      )}

      {processedData.map((p, i) => {
        if (p.prixActuel === null || p.prixPrecedent === null) return null;

        const difference = p.prixActuel - p.prixPrecedent;
        
        
        let icon = "→"; 
        let iconColor = "#9e9e9e"; 
        let tendance = "est resté stable";

        if (difference > 0) {
          icon = "↗";
          iconColor = "#d32f2f"; // Rouge (Hausse de prix)
          tendance = "a augmenté";
        } else if (difference < 0) {
          icon = "↘";
          iconColor = "#2e7d32"; // Vert (Baisse de prix)
          tendance = "a diminué";
        }

        const valeurAbs = Math.abs(difference).toFixed(0).toLocaleString();

        return (
          <Typography 
            component="li" 
            key={i} 
            fontSize="0.85vw" 
            sx={{ 
                display: 'flex', 
                gap: 1.5, 
                p: 1, 
                borderRadius: '8px',
                bgcolor: 'white',
                boxShadow: '0 2px 4px rgba(0,0,0,0.02)'
            }}
          >
            <b style={{ color: iconColor, fontSize: '1.2vw', lineHeight: 1 }}>{icon}</b>
            <span>
              <b>{p.marche}</b>,
                                     {p.nbrCollecteActuel && p.nbrCollecteActuel > 1
                                            ? <> avec <b>{p.nbrCollecteActuel}</b> fiches, </>
                                            : " "}
                                        le prix de <b>{produit}</b>  {tendance}
                                        {difference !== 0 && <> de <b>{valeurAbs} FCFA</b></>}
                                         {" "} depuis la date du  {" "}
                                        <b>{formatDateToDDMMYYYY(p.datePrecedente)}</b>.
            </span>
          </Typography>
        );
      })}
    </Stack>
  </Stack>
</Grid> */}
{/* POINTS À RETENIR END */}

            {/* </Grid> */}
        </Stack>
    );
};


export default PageContentProduitProvince;


